import { getShopInfo } from '../../api/shop'

const shop = {
  state: {
    shopInfo: null
  },
  mutations: {
    SET_SHOPINFO: (state, shopInfo) => {
      state.shopInfo = shopInfo
    }
  },
  actions: {
    GetShopInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getShopInfo()
          .then(response => {
            commit('SET_SHOPINFO', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
}

export default shop



// WEBPACK FOOTER //
// ./src/store/modules/shop.js